
















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class DialogWrapper extends Vue {
  @Prop() title!: string;
  @Prop() message!: string;
}
